<template>
  <div class="toolbar-list">
    <a-tooltip placement="top" title="密度">
      <a-dropdown :trigger="['click']" placement="bottomRight">
        <a-icon type="shrink" class="ant-dropdown-link" title="密度" />
        <a-menu slot="overlay">
          <a-menu-item :key="item.key" :class="item.key === densityKey ? 'ant-dropdown-active' : ''" v-for="item in density" @click="changeDensityKey(item.key)">
            {{ item.name }}
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </a-tooltip>
    <a-tooltip placement="top" title="全屏" v-if="element">
      <a-icon type="fullscreen" title="全屏" @click="screenFull" />
    </a-tooltip>
    <a-tooltip placement="top" title="刷新">
      <a-icon type="reload" title="刷新" @click="getListReload" />
    </a-tooltip>
    <a-tooltip placement="top" title="列设置" v-if="columns.length > 0">
      <a-dropdown :trigger="['click']" placement="bottomRight" v-model="visible">
        <a-icon type="setting" class="ant-dropdown-link" title="列设置" />
        <a-menu slot="overlay" mode="vertical">
          <a-menu-item>
            <a-checkbox v-model="columnsChecked" @change="toggleColumnsChange">
              列展示
            </a-checkbox>
            <a @click="resetColumns">
              重置
            </a>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item-group v-if="columnsList.filter(item => item.fixed === 'left').length !== 0">
            <template slot="title">固定在左侧</template>
            <a-menu-item :key="item.key" v-for="item in columnsList.filter(item => item.fixed === 'left')">
              <a-checkbox :checked="item.checked" @change="val => columnsChange(val,item.dataIndex)">
                {{ item.title }}
              </a-checkbox>
              <div class="action-hover">
                <a-tooltip placement="top" :title="!item.fixed ? '固定到左侧' : '取消固定'">
                  <a-icon :type="!item.fixed ? 'pushpin' : 'vertical-align-middle'" class="left" @click="flexOnLeft(item.dataIndex)" />
                </a-tooltip>
                <a-tooltip placement="top" title="固定到右侧">
                  <a-icon type="pushpin" class="right" @click="flexOnRight(item.dataIndex)" />
                </a-tooltip>
              </div>
            </a-menu-item>
          </a-menu-item-group>
          <a-menu-item-group v-if="columnsList.filter(item => item.fixed === 'right').length !== 0">
            <template slot="title">固定在右侧</template>
            <a-menu-item :key="item.key" v-for="item in columnsList.filter(item => item.fixed === 'right')">
              <a-checkbox :checked="item.checked" @change="val => columnsChange(val,item.dataIndex)">
                {{ item.title }}
              </a-checkbox>
              <div class="action-hover">
                <a-tooltip placement="top" title="固定到左侧">
                  <a-icon type="pushpin" class="left" @click="flexOnLeft(item.dataIndex)" />
                </a-tooltip>
                <a-tooltip placement="top" :title="!item.fixed ? '固定到右侧' : '取消固定'">
                  <a-icon :type="!item.fixed ? 'pushpin' : 'vertical-align-middle'" class="right" @click="flexOnRight(item.dataIndex)" />
                </a-tooltip>
              </div>
            </a-menu-item>
          </a-menu-item-group>
          <a-menu-item-group>
            <template slot="title" v-if="columnsList.filter(item => item.fixed === 'right').length !== 0 || columnsList.filter(item => item.fixed === 'left').length !== 0">不固定</template>
            <a-menu-item :key="item.key" v-for="item in columnsList.filter(item => !item.fixed)">
              <a-checkbox :checked="item.checked" @change="val => columnsChange(val,item.dataIndex)">
                {{ item.title }}
              </a-checkbox>
              <div class="action-hover">
                <a-tooltip placement="top" title="固定到左边">
                  <a-icon type="pushpin" class="left" @click="flexOnLeft(item.dataIndex)" />
                </a-tooltip>
                <a-tooltip placement="top" title="固定到右边">
                  <a-icon type="pushpin" class="right" @click="flexOnRight(item.dataIndex)" />
                </a-tooltip>
              </div>
            </a-menu-item>
          </a-menu-item-group>
        </a-menu>
      </a-dropdown>
    </a-tooltip>
  </div>
</template>

<script>
import screenfull from 'screenfull'

export default {
  name: 'TableToolBarList',
  props: {
    element: {
      type: String,
      default: ''
    },
    columns: {
      type: [Object, Array],
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      density: [
        {
          key: 0,
          name: '默认'
        },
        {
          key: 1,
          name: '中等'
        },
        {
          key: 2,
          name: '紧凑'
        }
      ], // 表格密度
      densityKey: 0, // 表格密度值
      densitySize: 'default',
      visible: false, // 设置表头下拉框点击不关闭
      columnsChecked: true,
      columnsList: this.$props.columns ? JSON.parse(JSON.stringify(this.$props.columns)) : null /// / 深度复制
    }
  },
  mounted () {
    if (this.$props.columns) {
      const columns = JSON.parse(JSON.stringify(this.$props.columns))
      columns.filter(item => {
        if (item.checked !== false) {
          item.checked = true
        }
      })
      this.columnsList = columns
    }
  },
  methods: {
    /**
     * 点击切换全屏
     *
     * @element
     */
    screenFull () {
      const element = document.querySelector(this.$props.element)
      // 如果不允许进入全屏，发出不允许提示
      if (screenfull.isEnabled) {
        screenfull.toggle(element)
      }
    },
    /**
     * 刷新列表
     * @returns $emit
     */
    getListReload () {
      this.$emit('reload')
    },
    /**
     * 列展示
     *
     * @columnsChecked
     */
    toggleColumnsChange () {
      const columnsList = [...this.columnsList]
      columnsList.filter(item => {
        item.checked = this.columnsChecked
      })
      this.$emit('change', '', columnsList.filter(item => item.checked === true))
    },
    /**
     * 重置按钮
     * @oldColumns
     */
    resetColumns () {
      this.columnsChecked = true
      this.columnsList = JSON.parse(JSON.stringify(this.$props.columns)) // 深度复制
      this.$emit('change', '', this.columnsList)
    },
    /**
     * 点击左侧固定
     *
     * @columns
     */
    flexOnLeft (index) {
      const newColumns = [...this.columnsList]
      const target = newColumns.filter(item => index === item.dataIndex)[0]
      if (target) {
        target.fixed = target.fixed === 'left' ? undefined : 'left'
        this.columnsList = newColumns
      }
      this.$emit('change', '', newColumns)
    },
    /**
     * 点击右侧固定
     *
     * @columns
     */
    flexOnRight (index) {
      const newColumns = [...this.columnsList]
      const target = newColumns.filter(item => index === item.dataIndex)[0]
      if (target) {
        target.fixed = target.fixed === 'right' ? undefined : 'right'
        this.columnsList = newColumns
      }
      this.$emit('change', '', newColumns)
    },
    /**
     * 点击切换表头
     *
     * @columns
     */
    columnsChange (val, index) {
      const newColumns = [...this.columnsList]
      const target = newColumns.filter(item => index === item.dataIndex)[0]
      if (target) {
        target.checked = val.target.checked
        this.columnsList = newColumns
      }
      this.$emit('change', '', this.columnsList.filter(item => item.checked === true))
    },
    /**
     * 点击切换表格密度
     *
     * @densityKey
     */
    changeDensityKey (val) {
      this.densityKey = val
      switch (val) {
        case 0:
          this.densitySize = 'default'
          break
        case 1:
          this.densitySize = 'middle'
          break
        case 2:
          this.densitySize = 'small'
          break
      }
      this.$emit('change', this.densitySize, '')
    }
  }
}
</script>
<style lang="less" scoped>
@import '../index.less';

.toolbar-list {
  display: flex;
  align-items: center;
  & > *:not(:first-child) {
    margin-left: 15px;
  }
}

.ant-dropdown-active {
  background: #1890ff;
  color: #fff;
}

/deep/.ant-dropdown-menu-item-group-list {
  margin: 0;
}
/deep/.ant-dropdown-menu-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px 20px;
  min-width: 80px;
  &:hover {
    .action-hover {
      visibility: visible;
    }
  }
  .action-hover {
    visibility: hidden;
    .left {
      transform: rotate(-90deg);
      margin-right: 10px;
    }
  }
}

</style>
